export default "__VITE_ASSET__DVtqQ5t___"